{
  "title": "仪表板",
  "greeting": "早上好，{{name}}",
  "greetingAnonymous": "早上好",
  "scope": {
    "onlyMine": "仅我的",
    "workspaceTrigger": "切换工作区",
    "teamTrigger": "切换团队",
    "allWorkspaces": "所有工作区",
    "allTeams": "所有团队",
    "searchPlaceholder": "搜索…",
    "pickerEmpty": "未找到"
  },
  "summary": {
    "mine": "{{attention}} 项需要你处理 · 未来 {{days}} 天内有 {{shoots}} 场你的拍摄",
    "workspace": "{{attention}} 项需要关注 · 未来 {{days}} 天内有 {{shoots}} 场拍摄",
    "organization": "组织内有 {{attention}} 项需要关注 · 未来 {{days}} 天内有 {{shoots}} 场拍摄",
    "team": "该团队有 {{attention}} 项需要关注 · 未来 {{days}} 天内有 {{shoots}} 场拍摄"
  },
  "sections": {
    "nextShoots": "即将拍摄",
    "nextShootsHint": "最近几场拍摄的准备情况",
    "attention": "需要关注",
    "attentionHint": "最紧急的排在最前；处理完成后该行会消失",
    "pulse": "概览",
    "pulseHint": "未来 {{days}} 天",
    "timeline": "未来 {{days}} 天",
    "timelineHint": "按泳道排列的拍摄日期；指向色条查看团队与状态",
    "workspaces": "工作区",
    "workspacesHint": "当前工作量与风险所在"
  },
  "shoot": {
    "open": "打开制作",
    "untitled": "未命名制作",
    "crewMeter": "已预订团队",
    "callsheetMeter": "通告单",
    "callsheet_shared": "已发送",
    "callsheet_building": "编写中",
    "callsheet_missing": "尚未开始"
  },
  "status": {
    "active": "拍摄中",
    "ready": "已就绪",
    "resourcing": "招募中",
    "alert": "有风险",
    "draft": "尚无角色",
    "complete": "已完成"
  },
  "when": {
    "today": "今天",
    "tomorrow": "明天",
    "inDays_other": "{{count}} 天后"
  },
  "stats": {
    "shoots": "拍摄",
    "shootsHint": "未来 {{days}} 天内",
    "rolesFilled": "已预订角色",
    "rolesFilledHint": "{{total}} 个角色中的 {{booked}} 个",
    "pencils": "待确认的暫定预订",
    "pencilsHint": "未来 {{days}} 天内的预留",
    "attention": "需要关注",
    "attentionHint": "项等待处理",
    "availability": "档期询问",
    "availabilityHint": "已发出，尚未回复"
  },
  "filters": {
    "all": "全部",
    "resourcing": "招募",
    "availability": "档期",
    "callsheets": "通告单",
    "bookings": "预订"
  },
  "attention": {
    "ariaLabel": "需要关注的事项",
    "empty": "这里没有待处理的事项。",
    "rolesUnfilled": {
      "title_other": "{{production}} 有 {{count}} 个角色尚未确定",
      "description": "拍摄开始于 {{date}}",
      "action": "寻找团队"
    },
    "callsheetMissing": {
      "title": "{{production}} 还没有通告单",
      "description_other": "已预订 {{count}} 位团队成员",
      "action": "打开"
    },
    "callsheetBuilding": {
      "title": "{{production}} 的通告单尚未发送",
      "description": "收件人还没有集合信息",
      "action": "打开"
    },
    "availability": {
      "title": "{{resource}} 尚未回复",
      "someone": "该资源",
      "description": "询问的档期：{{range}}",
      "due_other": "已等待 {{count}} 天",
      "dueToday": "今天发出",
      "action": "打开资源"
    },
    "pencils": {
      "title_other": "{{count}} 个暫定预订需要确认",
      "description": "未来 {{days}} 天内的预留",
      "due": "本时段",
      "action": "打开预订"
    }
  },
  "timeline": {
    "empty": "该时段内没有拍摄。",
    "unassigned": "未分配团队",
    "crew": "已预订团队 {{booked}} / {{total}}",
    "demandTitle": "每日人员",
    "demandHint": "该时段内每天需要多少人",
    "demandEmpty": "该时段内无需人员。",
    "demandBookedShort": "已预订",
    "demandUnfilledShort": "待补",
    "demandBooked_other": "已预订 {{count}} 人",
    "demandUnfilled_other": "{{count}} 个岗位尚未确定",
    "legend": {
      "active": "拍摄中",
      "ready": "已就绪",
      "resourcing": "招募中",
      "alert": "有风险"
    }
  },
  "workspaces": {
    "shoots_other": "未来 {{days}} 天内有 {{count}} 场拍摄",
    "rolesFilled": "已预订角色",
    "attention": "{{value}} 项待处理",
    "noAttention": "一切顺利",
    "open": "打开",
    "emptyTitle": "还没有工作区",
    "empty": "该组织还没有工作区。"
  },
  "loadError": "无法加载仪表板。",
  "demo": {
    "toggle": "查看仪表板的潜力",
    "bannerTitle": "您正在查看示例数据",
    "bannerMessage": "这是虚构的忙碌两周，展示当您的拍摄、团队和通告单都在 Atellio 中时仪表板的样子。链接已停用。",
    "exit": "返回我的数据"
  }
}
